import ModuleTopics from './ModuleTopics';

export default ModuleTopics;
export * from './ModuleTopics';
